import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation, Trans } from 'react-i18next';
import { Icon } from 'semantic-ui-react';

import FactoryContainer from '../../containers/FactoryContainer';

import FactoriesContainer from '../../containers/FactoriesContainer';
import SiteWrapperContainer from '../../containers/SiteWrapperContainer';
import DashboardContainer from '../../containers/DashboardContainer';
import BrandsContainer from '../../containers/BrandsContainer';
import DevicesContainer from '../../containers/DevicesContainer';
import ReportContainer from '../../containers/ReportContainer';
import ReportChartsContainer from '../../containers/ReportChartsContainer';
import TrendsContainer from '../../containers/TrendsContainer';
import DiagramContainer from '../../containers/DiagramContainer';
import ModelsContainer from '../../containers/ModelsContainer';
import ProtocolsContainer from '../../containers/ProtocolsContainer';
import ChannelsContainer from '../../containers/ChannelsContainer';
import ItemsContainer from '../../containers/ItemsContainer';
import AlertsContainer from '../../containers/AlertsContainer';
import AlertsSettingContainer from '../../containers/AlertsSettingContainer';
import InvoicesContainer from '../../containers/InvoicesContainer';
import SettingPriceContainer from '../../containers/SettingPriceContainer';
import SettingDashboardContainer from '../../containers/SettingDashboardContainer';
import ReportDevicesContainer from '../../containers/ReportDevicesContainer';
import ReportChartsCompareContainer from '../../containers/ReportChartsCompareContainer';
import RebootSystemContainer from '../../containers/RebootSystemContainer';
import ArchitectureContainer from '../../containers/ArchitectureContainer';
import SettingEmailsContainer from '../../containers/SettingEmailsContainer';

import Paths from '../../constants/Paths';

import styles from './Static.module.scss';

const Static = ({ pathName, deviceId, siteId, factoryId }) => {
  const [t] = useTranslation();

  switch (pathName) {
    case Paths.DASHBOARD:
      return (
        <div className="content-inner">
          <DashboardContainer />
        </div>
      );
    case Paths.LIST_SITES:
      return (
        <div className="content-inner">
          <FactoriesContainer />
        </div>
      );
    case Paths.BRANDS:
      return (
        <div className="content-inner">
          <BrandsContainer />
        </div>
      );
    case Paths.LIST_MODELS:
      return (
        <div className="content-inner">
          <ModelsContainer />
        </div>
      );
    case Paths.LIST_PROTOCOLS:
      return (
        <div className="content-inner">
          <ProtocolsContainer />
        </div>
      );
    case Paths.LIST_CHANNELS:
      return (
        <div className="content-inner">
          <ChannelsContainer />
        </div>
      );
    case Paths.LIST_ITEMS:
      return (
        <div className="content-inner">
          <ItemsContainer />
        </div>
      );
    case Paths.LIST_ALERTS:
      return (
        <div className="content-inner">
          <AlertsContainer />
        </div>
      );
    case Paths.LIST_ALERTS_SETTING:
      return (
        <div className="content-inner">
          <AlertsSettingContainer />
        </div>
      );
    case Paths.LIST_DEVICES:
      return (
        <div className="content-inner">
          <DevicesContainer />
        </div>
      );
    case Paths.CHARTS:
      return (
        <div className="content-inner">
          <ReportChartsContainer />
        </div>
      );
    case Paths.CHARTS_COMPARE:
      return (
        <div className="content-inner">
          <ReportChartsCompareContainer />
        </div>
      );
    case Paths.DIAGRAM:
      return (
        <div className="content-inner">
          <DiagramContainer />
        </div>
      );
    case Paths.REPORTS:
      return (
        <div className="content-inner">
          <ReportContainer />
        </div>
      );
    case Paths.REPORT_DEVICE:
      return (
        <div className="content-inner">
          <ReportDevicesContainer />
        </div>
      );
    case Paths.TRENDS:
      return (
        <div className="content-inner">
          <TrendsContainer />
        </div>
      );
    case Paths.SETTING_INVOICES:
      return (
        <div className="content-inner">
          <InvoicesContainer />
        </div>
      );
    case Paths.SETTING_PRICES:
      return (
        <div className="content-inner">
          <SettingPriceContainer />
        </div>
      );
    case Paths.SETTING_EMAILS:
      return (
        <div className="content-inner">
          <SettingEmailsContainer />
        </div>
      );
    case Paths.SETTING_DASHBOARD:
      return (
        <div className="content-inner">
          <SettingDashboardContainer />
        </div>
      );
    case Paths.REBOOT_SYSTEM:
      return (
        <div className="content-inner">
          <RebootSystemContainer />
        </div>
      );
    case Paths.ARCHITECTURE:
      return (
        <div className="content-inner">
          <ArchitectureContainer />
        </div>
      );
    default:
  }

  if (factoryId === undefined) {
    return (
      <div className={`content-inner ${styles.root}`}>
        <DashboardContainer />
      </div>
    );
  }

  if (deviceId === null) {
    return (
      <div className={classNames(styles.root, styles.flex)}>
        <div className={styles.message}>
          <h1>
            {t('common.deviceNotFound', {
              context: 'title',
            })}
          </h1>
        </div>
      </div>
    );
  }

  if (siteId === null) {
    return (
      <div className={classNames(styles.root, styles.flex)}>
        <div className={styles.message}>
          <h1>
            {t('common.siteNotFound', {
              context: 'title',
            })}
          </h1>
        </div>
      </div>
    );
  }

  if (factoryId === null) {
    return (
      <div className={classNames(styles.root, styles.flex)}>
        <div className={styles.message}>
          <h1>
            {t('common.factoryNotFound', {
              context: 'title',
            })}
          </h1>
        </div>
      </div>
    );
  }

  if (siteId === undefined) {
    return (
      <div className={classNames(styles.site)}>
        <FactoryContainer />
        <div className={styles.message}>
          <Icon inverted name="hand point up outline" size="huge" className={styles.messageIcon} />
          <h1 className={styles.messageTitle}>
            {t('common.openSite', {
              context: 'title',
            })}
          </h1>
          <div className={styles.messageContent}>
            <Trans i18nKey="common.createNewOneOrSelectExistingOne" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={classNames(styles.site)}>
      <FactoryContainer />
      <SiteWrapperContainer />
    </div>
  );
};

Static.propTypes = {
  pathName: PropTypes.string,
  deviceId: PropTypes.string,
  siteId: PropTypes.string,
  factoryId: PropTypes.string,
};

Static.defaultProps = {
  pathName: undefined,
  deviceId: undefined,
  siteId: undefined,
  factoryId: undefined,
};

export default Static;
